<template>
  <Select v-if="!isSubAction" :options="collectionOptions" :value="action.collection" @changeValue="changeValue('collection', $event)" placeholder="Collection" :disabled="disabled" />
  <component :is="finalActionValue" :config="config" />
</template>

<script>
export default {
  emits: ['changeValue'],
  computed: {
    store() {
      return this.config?.store
    },
    storeId() {
      return this.config?.storeId
    },
    event() {
      return this.config?.event ?? null
    },
    more() {
      return this.config?.more || {}
    },
    action() {
      return this.config?.action || {}
    },
    packages() {
      return this.more?.action_packages || {}
    },
    collections() {
      return this.store.getter('collections') || {}
    },
    collectionOptions() {
      const collections = this.packages?.[this.action?.package]?.collections || []
      const conditions = Object.entries(this.more.collections).reduce((result, [key, value]) => {
        if (!value.is_special && collections.includes(key)) {
          result.push({
            id: key,
            text: value.label
          })
        }
        return result
      }, [])
      return Object.entries(this.collections).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value.label
        })
        return result
      }, conditions)
    },
    finalActionValue() {
      let packageName = null
      if (Object.keys(this.more?.collections || {}).includes(this.action.collection)) {
        packageName = _.pascalCase(this.action.collection)
      }
      return packageName ? `ActionValue${packageName}` : null
    }
  },
  methods: {
    changeValue(field, value) {
      this.$emit('changeValue', {
        field,
        value
      })
    }
  },
  props: {
    config: Object,
    disabled: {
      type: Boolean,
      default: false
    },
    isSubAction: {
      type: Boolean,
      default: false
    }
  }
}
</script>
